const en = {
	uploadSuccess: 'The upload was successful',
	uploadTitle: 'Upload the articles of incorporation',
	sizeText: 'Support JPG/PNG/PDF, no more than 5M per file',
	upload: 'Select file',
	cashAccount: 'Withdrawal Account',
	currentzAccount: 'Currentz Account',
	currentzAccountText: 'You have not applied to open a Currentz account for settlement and disbursement.',
	currentzAccountText1: 'You have applied to open a Currentz account for settlement and disbursement.',
	descriptionOfWithdrawals: 'VA withdrawal manuals',
	addbankAccount: 'Add bank card',
	applyforVirtualAccount: 'Apply for a virtual account',
	applyCurrentz: 'Apply for Currentz account',
	applyCurrentzTip: 'The currentz account is a multi-currency account of PingPong Currentz, which can be used for non-withdrawal purposes such as payment to suppliers. Click on "confirm" indicates the agreement to open a currentz account.',
	virtualName: 'Virtual Account Name',
	defaultNameTip: 'The account name will be synchronized to the pingpong collectionplatform for correspondence. If it is not filled in, the system default name will be used',
	virtualCurrency: 'Virtual Account Currency',
	currencyTip: 'Please select the currencies supported under this VA account. You can select multiple currencies.',
	addCurrency: 'Add Currency',
	delete: 'Delete Cash Account',
	deleteAccountTip: 'Your current account will be credited with the money in the payment. Are you sure to delete this account? The money will be credited to the original account.',
	deleteSureTip: 'Are you sure you want to delete this cash account?',
	association: 'If you need a virtual account in EUR/GBP/PLN currency，please upload the articles of incorporation first',
	return: 'return',
	buttonDelete: 'delete',
	cancel: 'cancel',
	goInput: 'Upload',
	inReview: 'In Review',
	reviewFailed: 'Review Failed',
	reviewPending: 'Under Review',
	modifyBank: 'Modify Bank Account',
	accountInfo: 'Account Information',
	comfirm: 'Comfirm',
	currency: 'Currency',
	bankName: 'Bank Name',
	cardNo: 'Card No.',
	iban: 'IBAN',
	swiftCode: 'swift code',
	bankCode: 'Bank Code',
	bankCountry: 'Bank Country',
	reservedPhoneNo: 'Reserved PhoneNo',
	virtualAccountName: 'Cash Account',
	virtualSuccess: 'Virtual Account created successfully!',
	exceed: 'The number of virtual accounts can not exceed the number of websites',
	created: 'virtual acount created successfully',
	atleast: 'Please select at least one currency',

	awd: {
		warmTips: 'Warm Tips',
		notSet: 'Withdrawal account not selected',
		toSet: 'Go to set up',
		skipSet: 'Not set, this currency will not be able to withdraw automatically',
		autoWithdrawal: 'Auto-withdrawal function',
		autoWithdrawalSet: 'Auto-withdrawal settings',
		topTip: 'When you turn on the auto-withdrawal function, we will automatically apply for withdrawal of all withdrawable amounts in your account at the time specified by you.',
		periodicity: 'Auto-withdrawal period',
		minAmount: 'minimum withdrawal amount',
		setMinAmount: 'Set minimum withdrawal amount',
		limitAmount: 'The minimum withdrawal amount shall be greater than $100.',
		setMinTips: 'After setting the minimum withdrawal amount, when the amount in the account is greater than or equal to this amount, automatic withdrawal will be initiated according to the "automatic withdrawal frequency". If the account currency is not US dollars, it will be converted into US dollars and compared with the withdrawal amount. The withdrawal amount setting will be applied to all accounts.',
		enabled: 'Enabled',
		unenabled: 'Disabled',
		unconfigured: 'Unconfigured',
		detail: 'Details',
		set: 'Set',
		currency: 'Currency',
		withdrawalTo: 'Withdrawal To',
		warnTitle: 'Notice for auto-withdrawal',
		confirmSet: 'I understand',
		edit: 'Edit auto-withdrawal settings',
		save: 'Save settings',
		cancel: 'Cancel modification',
		agree: 'I have read and agree to the above notice of auto-withdrawal',
		pleaseRead: 'Please read and agree to the above notice',
		close: 'Reason for deactivation of automatic withdrawals：',
		modifyAccountTip: 'This account has been set up for automatic withdrawal. Modifying this account will result in the corresponding currency not being able to withdraw automatically. ',
		deleteAccountTip: 'This account has been set up for automatic withdrawal. Deleting this account will result in the corresponding currency not being able to withdraw automatically. ',
		tips: [
			['1. You promise to provide us with all necessary information promptly during the application and use of the PingPong Checkout Automatic Withdrawal Service, and you are fully responsible for the accuracy, legality, truthfulness, completeness, and validity of the information provided; otherwise, you shall bear all losses caused to PingPong.'],
			['2. Rules for Automatic Withdrawal Service:', [
				'(1)	You can open the Automatic Withdrawal Service by going to the Merchant Service Platform- Account Center - Withdrawal Account. After this operation, PingPong will initiate the automatic withdrawal process according to the rules you set.',
				'(2)	The Automatic Withdrawal Service only supports full withdrawal of the total net value. If there is a negative value in the GROUP account of a currency in your PingPong Checkout account, the total net value of that currency or the total net value of the PingPong Checkout account (depending on which is lower) will be withdrawn. The order of withdrawal of funds is subject to the order of the GROUP accounts listed in your Merchant Service Platform, namely from top to bottom.',
				'(3)	If your withdrawable amount is less than the corresponding Automatic Withdrawal Service fee, automatic withdrawal will not be triggered.',
				'(4)	After setting the minimum withdrawal amount, when the amount in the account is greater than or equal to this amount, automatic withdrawal will be initiated according to the "automatic withdrawal frequency". If the account currency is not US dollars, it will be converted into US dollars and compared with the withdrawal amount. The withdrawal amount setting will be applied to all accounts.',
				'(5)	The automatic withdrawal is triggered at 0:00 UTC+0 on workdays (8:00 Beijing time), depending on the frequency of the Automatic Withdrawal Service you set. In the event of European Luxembourg or Chinese holidays, processing of the withdrawal will be postponed to the first working day after the holiday.',
				'(6)	After the automatic withdrawal is triggered, PingPong will review the automatic withdrawal application based on its internal compliance policies and risk management requirements. If your automatic withdrawal application fails to meet PingPong’s compliance policies or risk management requirements, PingPong is entitled to reject your automatic withdrawal application.',
				'(7)	If your automatic withdrawal application is rejected more than 3 times (including 3 times) within 14 consecutive natural days, PingPong will automatically disable your automatic withdrawal function. After this operation, you can reset and enable the automatic withdrawal function again.',
				'(8)	PingPong has the right to review your PingPong Checkout account transactions and related operations. If any risks are found, PingPong is entitled to disable your automatic withdrawal function. In this case, you will not be able to re-enable the automatic withdrawal function.'
			]],
			['3. PingPong Checkout Automatic Withdrawal Service fee depends on the currency, and the specific charging rules are subject to the rules agreed upon by PingPong and you.'],
			['4. If you wish to disable the Automatic Withdrawal Service after activating it, please operate accordingly by going to the Merchant Service Platform - Account Center - Withdrawal Account.'],
			['5. We are not responsible for any delay, interruption or failure of Automatic Withdrawal Service due to the following reasons: (i) your reasons (including but not limited to inaccurate information provided by you, failure to provide withdrawal account, entry rejection of withdrawal account provided by you, etc.); (ii) third-party reasons (including but not limited to third-party system failures, policy changes, etc.); (iii) network failures, force majeure and other factors.'],
			['6. By confirming the activation of PingPong Checkout Automatic Withdrawal Service, you agree to authorize us (i) to obtain and use all information provided by you, and (ii) to provide necessary information (including but not limited to withdrawal account) to service providers to facilitate this Automatic Withdrawal Service.'],
			['7. By clicking the confirmation button on the web page, you agree to accept all the terms and conditions of these Notes, as well as the rules, including but not limited to the published rules or rules to be published in the future, page displays, operation procedures, announcements or notices related to these Notes (hereinafter referred to as the Rules), and PingPong is entitled to modify and immediately validate the content of these Notes and Rules at any time. If you continue to use the PingPong Checkout Automatic Withdrawal Service after the changes to these Notes, you are deemed to agree to such changes. If you disagree with the above terms, you may not apply for or continue to use the PingPong Checkout Automatic Withdrawal Service.']
		]
	},
	accountCenter: {
		bankAccountName: 'Beneficiary Account Name',
		accountCenterTitle: 'Account Center',
		clientId: 'client ID',
		accountInformation: 'Account Information',
		emailAddress: 'Email Address',
		phoneNumber: 'Phone Number',
		identityVerification: 'Identity Verification',
		remittanceAccount: 'Account open area',
		accountOpenArea: 'Account open area',
		select: 'Please choose one of the following items',
		selectShort: 'Please select',
		hongkong: 'Hongkong, China',
		mainLand: 'Mainland, China',
		europe: 'Europe',
		america: 'America',
		singapore: 'Singapore',
		korea: 'Korea',
		japan: 'Japan',
		uk: 'United Kingdom',
		usd: 'USD',
		rmb: 'CNY',
		eur: 'EUR',
		gbp: 'GBP',
		aud: 'AUD',
		hkd: 'HKD',
		sgd: 'SGD',
		krw: 'KRW',
		cnh: 'CNH',
		jpy: 'JPY',
		cad: 'CAD',
		sek: 'SEK',
		nok: 'NOK',
		accountCurrency: 'Account currency',
		companyLegalName: 'Company Legal Name',
		companyLegalNameInEnglish: 'Company Legal Name in English',
		bankName: 'Bank name',
		bankAccountNumber: 'Bank account number',
		iban: 'IBAN',
		swiftCode: 'Swift code',
		searchSwiftCode: 'Search Swift code',
		bankBranchName: 'Bank branch name',
		bankCode: 'Sort code',
		bankCountry: 'Bank Country',
		bankBranchAddress: 'Bank branch address',
		bankBranchDetailAddress: 'Bank branch specific address',
		phoneNumber2: 'Phone number',
		bankAccountEmail: 'Receiver email',
		shortCardNo: 'Sort Code',
		bankAccountCertificate: 'Bank Account Certificate',

		isVa: 'Is it a virtual account of PingPong',
		yes: 'YES',
		no: 'NO',
		registeredPhoneNumber: 'Registered phone number',
		verificationCode: 'Verification code',
		getaVerificationCode: 'Get a verification code',
		confirm: 'Confirm',
		cancel: 'cancel',
		comfirmbtn: 'confirm',
		resendAfter30s: 'Resend after',
		pleaseSelectAccountOpenArea: 'Please select account open area',
		pleaseSelectAccountCurrency: 'Please select account currency',
		pleaseEntrySortCode: 'Please enter Sort Code',
		pleaseEnterBankName: 'Please enter bank name',
		pleaseEnterBankAccountNumber: 'Please enter bank account number',
		pleaseEnterRightBankAccountNumber: 'The bank card number can only be filled with English letters and numbers',
		pleaseEnterIban: 'Please enter IBAN',
		pleaseEnterRightIban: 'The IBAN can only be filled with English letters and numbers',
		pleaseEnterSwiftCode: 'Please enter swift code',
		swiftCodeInvalid: 'Please enter either 8 or 11 uppercase letters or digits, without any spaces.',
		pleaseEnterBankBranchName: 'Please enter bank branch name',
		pleaseEnterAbaRoutingNumber: 'Please enter ACH Routing Number',
		pleaseEnterBankCode: 'Please enter Sort code',
		pleaseEnter3DigitsCode: 'Please fill in 3 digits',
		pleaseEnterBankBranchAddress: 'Please enter bank branch address',
		pleaseEnterVerificationCode: 'Please enter verification code',
		errorVerificaitonCode: 'The verification code is incorrect',
		invalidVerificationCode: 'Invalidation Verification code',
		accountAlreadyExists: 'Account already exists',
		successSubmit: 'Submit successfully',
		bankChineseName: 'Please enter bank name in chinese',
		bankbranchChineseName: 'Please enter bank branch name in chinese',
		bankbranchAddressChineseName: 'Please enter bank branch address in chinese',
		bankEnName: 'Please enter bank name in english',
		bankbranchEnName: 'Please enter bank branch name in english',
		bankbranchAddressEnName: 'Please enter bank branch address in english',
		pleaseEnterBankCountry: 'Please enter bank country in english',
		atleast: 'Please select at least one settlement currency', // 请至少选择一个结算币种
		pleaseEnterBankOpen: 'Please enter bank account certificate',
		pleaseEnterBankAccountEmail: 'Please enter receiver email',
		illegalBankAccountEmail: 'Please enter the correct receiver email'
	},
	remittance: {
		remittanceAccount: 'Remittance Account',
		modifyAccountInfo: 'Modify Account Info',
		failed1st: 'The information your submited audit failed ,',
		failed2nd:
      'Please revise and resubmit for review, if you have any question, Please ',
		failed3rd: 'Contact customer service',
		failedTips:
      'Failed to audit the payment account, please contact customer service as soon as possible to avoid affecting your capital flow.',
		pending:
      'Your payment account information is under review. After the review is passed, you can initiate withdrawal.',
		pending2nd:
      'Your bank account is under review. We will start remit for you automatically after it completes.',
		modalTipsWarn1: 'The',
		modalTipsWarn2: 'ongoing funds',
		modalTipsWarn3: 'will be remmited to your original account. If you hope the funds to remit to your new account, please contact out customer service.',
		confirm: 'Confirm'
	},
	vaState: {
		normal: '',
		exceed: 'The number of virtual accounts cannot exceed the number of websites',
		warn: 'The number of virtual accounts has reached the upper limit, the new one does not support CNY settlement through PingPong collection. Do you want to continue to create a virtual account?'
	},
	warningTip: 'Attention',
	contact: 'Contact US',
	editAccount: 'Modify Account Info'
}

export default en
